import {BehaviorSubject} from 'rxjs';
import {ClassType, GroupType, StudentType} from '../types';
import {BaseService} from '@esgi/core/service';
import {V2TeachersPagesActivitiesSectionsStudentsController} from '@esgi/contracts/esgi';

export class StudentService extends BaseService {
	public loaded$ = new BehaviorSubject(false);
	public classes$ = new BehaviorSubject<ClassType[]>([]);
	public groups$ = new BehaviorSubject<GroupType[]>([]);
	public students$ = new BehaviorSubject<StudentType[]>([]);
	private controllerV2 = new V2TeachersPagesActivitiesSectionsStudentsController();

	constructor() {
		super();

		this.controllerV2.init().subscribe({
			next: ({classes, students, groups}) => {
				this.classes$.next(classes);
				this.groups$.next(groups);
				this.students$.next(students);
			},
			complete: () => {
				this.loaded$.next(true);
			},
		});
	}

	public get(studentId: StudentType['id']) {
		return this.students$.value.find(({id}) => id === studentId);
	}

	public override dispose() {
		this.controllerV2.dispose();
		super.dispose();
	}
}
